import ajax from "../../plugins/AjaxService"


/**
 * Recupera dal BE il token da utilizzare per autenticarsi con COPILOTKIT
 */
const fetchToken = (): Promise<{ token: string }> => {
	return ajax.get(`short_token`)
}

const chatApi = {
	fetchToken,
}

export default chatApi